export default {
  // Page metadata
  'meta.title': 'ਸੇਵਾ ਦੀਆਂ ਸ਼ਰਤਾਂ - timer.today',
  'meta.description': 'timer.today ਔਨਲਾਈਨ ਸਮਾਂ ਟੂਲ ਪਲੇਟਫਾਰਮ ਲਈ ਸੇਵਾ ਦੀਆਂ ਸ਼ਰਤਾਂ ਅਤੇ ਵਰਤੋਂ ਸਮਝੌਤਾ। ਸਾਡੇ ਸੇਵਾ ਨਿਯਮਾਂ, ਉਪਭੋਗਤਾ ਅਧਿਕਾਰਾਂ ਅਤੇ ਜ਼ਿੰਮੇਵਾਰੀਆਂ ਬਾਰੇ ਜਾਣੋ।',

  // Page header
  'page.title': 'ਸੇਵਾ ਦੀਆਂ ਸ਼ਰਤਾਂ',
  'page.lastUpdated': 'ਆਖਰੀ ਅੱਪਡੇਟ: {{date}}',
  'page.intro': 'timer.today ਵਿੱਚ ਤੁਹਾਡਾ ਸਵਾਗਤ ਹੈ। ਇਹ ਸ਼ਰਤਾਂ ਅਤੇ ਸ਼ਰਤਾਂ timer.today ਦੀ ਵੈੱਬਸਾਈਟ ਦੀ ਵਰਤੋਂ ਲਈ ਨਿਯਮਾਂ ਅਤੇ ਨਿਯਮਾਂ ਦੀ ਰੂਪਰੇਖਾ ਦਿੰਦੀਆਂ ਹਨ, ਜੋ timer.today ਤੇ ਸਥਿਤ ਹੈ।',

  // Section 1
  'section1.title': '1. ਸ਼ਰਤਾਂ ਦੀ ਸਵੀਕ੍ਰਿਤੀ',
  'section1.content': 'ਇਸ ਵੈੱਬਸਾਈਟ ਤੱਕ ਪਹੁੰਚ ਅਤੇ ਇਸਦੀ ਵਰਤੋਂ ਕਰਕੇ, ਤੁਸੀਂ ਇਸ ਸਮਝੌਤੇ ਦੀਆਂ ਸ਼ਰਤਾਂ ਅਤੇ ਵਿਵਸਥਾਵਾਂ ਦੁਆਰਾ ਬੰਨ੍ਹੇ ਜਾਣ ਨੂੰ ਸਵੀਕਾਰ ਅਤੇ ਸਹਿਮਤ ਹੁੰਦੇ ਹੋ। ਜੇ ਤੁਸੀਂ ਉਪਰੋਕਤ ਦੀ ਪਾਲਣਾ ਕਰਨ ਲਈ ਸਹਿਮਤ ਨਹੀਂ ਹੋ, ਤਾਂ ਕਿਰਪਾ ਕਰਕੇ ਇਸ ਸੇਵਾ ਦੀ ਵਰਤੋਂ ਨਾ ਕਰੋ।',

  // Section 2
  'section2.title': '2. ਸੇਵਾ ਵੇਰਵਾ',
  'section2.intro': 'timer.today ਮੁਫਤ ਔਨਲਾਈਨ ਸਮਾਂ ਟੂਲ ਪ੍ਰਦਾਨ ਕਰਦਾ ਹੈ ਜਿਸ ਵਿੱਚ ਸ਼ਾਮਲ ਹਨ:',
  'section2.timer': 'ਉਲਟੀ ਗਿਣਤੀ ਟਾਈਮਰ - ਉਤਪਾਦਕਤਾ, ਖਾਣਾ ਬਣਾਉਣ ਅਤੇ ਸਮਾਂ ਪ੍ਰਬੰਧਨ ਲਈ ਅਨੁਕੂਲਿਤ ਟਾਈਮਰ',
  'section2.stopwatch': 'ਸਟਾਪਵਾਚ - ਖੇਡਾਂ, ਸਿਖਲਾਈ ਅਤੇ ਸਟੀਕ ਸਮਾਂ ਲਈ ਉੱਚ-ਸ਼ੁੱਧਤਾ ਸਮਾਂ ਟੂਲ',
  'section2.worldclock': 'ਵਿਸ਼ਵ ਘੜੀ - ਗਲੋਬਲ ਸਮਾਂ ਖੇਤਰਾਂ ਦਾ ਰੀਅਲ-ਟਾਈਮ ਡਿਸਪਲੇ',

  // Section 3
  'section3.title': '3. ਵਰਤੋਂ ਲਾਇਸੈਂਸ',
  'section3.intro': 'timer.today ਨੂੰ ਅਸਥਾਈ ਤੌਰ ਤੇ ਨਿੱਜੀ, ਗੈਰ-ਵਪਾਰਕ ਅਸਥਾਈ ਦੇਖਣ ਲਈ ਵਰਤਣ ਦੀ ਇਜਾਜ਼ਤ ਦਿੱਤੀ ਗਈ ਹੈ। ਇਹ ਇੱਕ ਲਾਇਸੈਂਸ ਦੀ ਮਨਜ਼ੂਰੀ ਹੈ, ਸਿਰਲੇਖ ਦਾ ਤਬਾਦਲਾ ਨਹੀਂ, ਅਤੇ ਇਸ ਲਾਇਸੈਂਸ ਦੇ ਤਹਿਤ ਤੁਸੀਂ ਨਹੀਂ ਕਰ ਸਕਦੇ:',
  'section3.item1': 'ਸਮੱਗਰੀ ਨੂੰ ਸੋਧੋ ਜਾਂ ਕਾਪੀ ਕਰੋ',
  'section3.item2': 'ਕਿਸੇ ਵੀ ਵਪਾਰਕ ਉਦੇਸ਼ ਜਾਂ ਕਿਸੇ ਜਨਤਕ ਪ੍ਰਦਰਸ਼ਨ ਲਈ ਸਮੱਗਰੀ ਦੀ ਵਰਤੋਂ ਕਰੋ',
  'section3.item3': 'ਵੈੱਬਸਾਈਟ ਤੇ ਮੌਜੂਦ ਕਿਸੇ ਵੀ ਸਾਫਟਵੇਅਰ ਦਾ ਰਿਵਰਸ ਇੰਜੀਨੀਅਰ ਕਰਨ ਦੀ ਕੋਸ਼ਿਸ਼ ਕਰੋ',
  'section3.item4': 'ਸਮੱਗਰੀ ਤੋਂ ਕੋਈ ਵੀ ਕਾਪੀਰਾਈਟ ਜਾਂ ਹੋਰ ਮਲਕੀਅਤ ਸੂਚਨਾਵਾਂ ਹਟਾਓ',

  // Section 4
  'section4.title': '4. ਗੋਪਨੀਯਤਾ ਅਤੇ ਡੇਟਾ',
  'section4.intro': 'timer.today ਤੁਹਾਡੀ ਗੋਪਨੀਯਤਾ ਦੀ ਰਾਖੀ ਕਰਨ ਲਈ ਵਚਨਬੱਧ ਹੈ:',
  'section4.item1': 'ਅਸੀਂ ਨਿੱਜੀ ਜਾਣਕਾਰੀ ਇਕੱਠੀ ਜਾਂ ਸਟੋਰ ਨਹੀਂ ਕਰਦੇ',
  'section4.item2': 'ਟਾਈਮਰ ਸੈਟਿੰਗਾਂ ਤੁਹਾਡੇ ਬ੍ਰਾਊਜ਼ਰ ਵਿੱਚ ਸਥਾਨਕ ਤੌਰ ਤੇ ਸਟੋਰ ਕੀਤੀਆਂ ਜਾਂਦੀਆਂ ਹਨ',
  'section4.item3': 'ਅਸੀਂ ਉਪਭੋਗਤਾ ਵਿਵਹਾਰ ਜਾਂ ਵਰਤੋਂ ਪੈਟਰਨਾਂ ਨੂੰ ਟ੍ਰੈਕ ਨਹੀਂ ਕਰਦੇ',
  'section4.item4': 'ਟ੍ਰੈਕਿੰਗ ਉਦੇਸ਼ਾਂ ਲਈ ਕੋਈ ਕੂਕੀਜ਼ ਵਰਤੀਆਂ ਨਹੀਂ ਜਾਂਦੀਆਂ',

  // Section 5
  'section5.title': '5. ਬੇਦਾਅਵਾ',
  'section5.content': 'timer.today ਤੇ ਸਮੱਗਰੀ "ਜਿਵੇਂ ਹੈ" ਅਧਾਰ ਤੇ ਪ੍ਰਦਾਨ ਕੀਤੀ ਗਈ ਹੈ। timer.today ਕੋਈ ਵਾਰੰਟੀ, ਸਪੱਸ਼ਟ ਜਾਂ ਅਪ੍ਰਤੱਖ ਨਹੀਂ ਦਿੰਦਾ, ਅਤੇ ਇਸ ਦੁਆਰਾ ਬੇਦਾਅਵਾ ਕਰਦਾ ਹੈ ਅਤੇ ਸਾਰੀਆਂ ਹੋਰ ਵਾਰੰਟੀਆਂ ਨੂੰ ਨਕਾਰਦਾ ਹੈ ਜਿਸ ਵਿੱਚ ਸੀਮਾ ਤੋਂ ਬਿਨਾਂ, ਅਪ੍ਰਤੱਖ ਵਾਰੰਟੀਆਂ ਜਾਂ ਵਪਾਰਯੋਗਤਾ ਦੀਆਂ ਸ਼ਰਤਾਂ, ਕਿਸੇ ਖਾਸ ਉਦੇਸ਼ ਲਈ ਢੁਕਵੀਂਤਾ, ਜਾਂ ਬੌਧਿਕ ਸੰਪੱਤੀ ਦੀ ਗੈਰ-ਉਲੰਘਣਾ ਜਾਂ ਅਧਿਕਾਰਾਂ ਦੀ ਹੋਰ ਉਲੰਘਣਾ ਸ਼ਾਮਲ ਹੈ।',

  // Section 6
  'section6.title': '6. ਸੀਮਾਵਾਂ',
  'section6.content': 'ਕਿਸੇ ਵੀ ਘਟਨਾ ਵਿੱਚ timer.today ਜਾਂ ਇਸਦੇ ਸਪਲਾਇਰ ਕਿਸੇ ਵੀ ਨੁਕਸਾਨ ਲਈ ਜਿੰਮੇਵਾਰ ਨਹੀਂ ਹੋਣਗੇ (ਜਿਸ ਵਿੱਚ, ਸੀਮਾ ਤੋਂ ਬਿਨਾਂ, ਡੇਟਾ ਜਾਂ ਲਾਭ ਦੇ ਨੁਕਸਾਨ ਲਈ ਨੁਕਸਾਨ, ਜਾਂ ਕਾਰੋਬਾਰ ਵਿੱਚ ਰੁਕਾਵਟ ਕਾਰਨ) timer.today ਤੇ ਸਮੱਗਰੀ ਦੀ ਵਰਤੋਂ ਜਾਂ ਵਰਤੋਂ ਕਰਨ ਵਿੱਚ ਅਸਮਰੱਥਾ ਤੋਂ ਪੈਦਾ ਹੁੰਦੇ ਹਨ, ਭਾਵੇਂ timer.today ਜਾਂ ਇਸਦੇ ਅਧਿਕਾਰਤ ਪ੍ਰਤੀਨਿਧੀ ਨੂੰ ਮੌਖਿਕ ਜਾਂ ਲਿਖਤੀ ਰੂਪ ਵਿੱਚ ਅਜਿਹੇ ਨੁਕਸਾਨ ਦੀ ਸੰਭਾਵਨਾ ਬਾਰੇ ਸੂਚਿਤ ਕੀਤਾ ਗਿਆ ਹੋਵੇ।',

  // Section 7
  'section7.title': '7. ਸਮੱਗਰੀ ਦੀ ਸ਼ੁੱਧਤਾ',
  'section7.content': 'timer.today ਤੇ ਦਿਖਾਈ ਦੇਣ ਵਾਲੀ ਸਮੱਗਰੀ ਵਿੱਚ ਤਕਨੀਕੀ, ਟਾਈਪੋਗ੍ਰਾਫਿਕ, ਜਾਂ ਫੋਟੋਗ੍ਰਾਫਿਕ ਗਲਤੀਆਂ ਸ਼ਾਮਲ ਹੋ ਸਕਦੀਆਂ ਹਨ। timer.today ਵਾਰੰਟੀ ਨਹੀਂ ਦਿੰਦਾ ਕਿ ਇਸਦੀ ਵੈੱਬਸਾਈਟ ਤੇ ਕੋਈ ਵੀ ਸਮੱਗਰੀ ਸਹੀ, ਸੰਪੂਰਨ, ਜਾਂ ਮੌਜੂਦਾ ਹੈ। timer.today ਬਿਨਾਂ ਨੋਟਿਸ ਦੇ ਕਿਸੇ ਵੀ ਸਮੇਂ ਆਪਣੀ ਵੈੱਬਸਾਈਟ ਤੇ ਮੌਜੂਦ ਸਮੱਗਰੀ ਵਿੱਚ ਤਬਦੀਲੀਆਂ ਕਰ ਸਕਦਾ ਹੈ।',

  // Section 8
  'section8.title': '8. ਸੋਧਾਂ',
  'section8.content': 'timer.today ਬਿਨਾਂ ਨੋਟਿਸ ਦੇ ਕਿਸੇ ਵੀ ਸਮੇਂ ਆਪਣੀ ਵੈੱਬਸਾਈਟ ਲਈ ਇਹਨਾਂ ਸੇਵਾ ਦੀਆਂ ਸ਼ਰਤਾਂ ਨੂੰ ਸੋਧ ਸਕਦਾ ਹੈ। ਇਸ ਵੈੱਬਸਾਈਟ ਦੀ ਵਰਤੋਂ ਕਰਕੇ, ਤੁਸੀਂ ਇਹਨਾਂ ਸੇਵਾ ਦੀਆਂ ਸ਼ਰਤਾਂ ਦੇ ਮੌਜੂਦਾ ਸੰਸਕਰਣ ਦੁਆਰਾ ਬੰਨ੍ਹੇ ਜਾਣ ਲਈ ਸਹਿਮਤ ਹੁੰਦੇ ਹੋ।',

  // Section 9
  'section9.title': '9. ਸੰਪਰਕ ਜਾਣਕਾਰੀ',
  'section9.intro': 'ਜੇ ਤੁਹਾਡੇ ਕੋਲ ਇਹਨਾਂ ਸੇਵਾ ਦੀਆਂ ਸ਼ਰਤਾਂ ਬਾਰੇ ਕੋਈ ਸਵਾਲ ਹਨ, ਤਾਂ ਕਿਰਪਾ ਕਰਕੇ ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ:',
  'section9.email': 'ਈਮੇਲ:',
  'section9.emailSubject': 'ਸੇਵਾ ਦੀਆਂ ਸ਼ਰਤਾਂ ਪੁੱਛਗਿੱਛ - timer.today',

  // Footer
  'footer.copyright': '© timer.today 2024. ਸਾਰੇ ਅਧਿਕਾਰ ਰਾਖਵੇਂ ਹਨ।'
};
